/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: { animationPaddingBottomAfter: 8, animationPaddingTopAfter: 8 }
    }
  ],
  tokens: {
    animationBackgroundColorAfter: '#efefef',
    animationBackgroundColorBefore: '#000000',
    animationColorAfter: '#000000',
    animationColorBefore: '#ffffff',
    animationDivColorAfter: '#000000',
    animationDivColorBefore: '#ffffff',
    animationHeightAfter: 24,
    animationHeightBefore: 0,
    animationPaddingBottomAfter: 16,
    animationPaddingBottomBefore: 0,
    animationPaddingTopAfter: 16,
    animationPaddingTopBefore: 0,
    chevronlinkFontName: 'StagSans',
    chevronlinkFontWeight: '400',
    containerBackgroundColor: '#000000',
    containerGap: 12,
    padding: 16
  }
}
export default theme
